import { useCallback, useEffect, useState } from 'react';

interface Countdown {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
}

export function useCountdown(targetDate: Date): Countdown {
  const calculateTimeLeft = useCallback((): Countdown => {
    const now = new Date();
    const difference = Math.max(
      0,
      Math.floor((targetDate.getTime() - now.getTime()) / 1000),
    );

    return {
      days: Math.floor(difference / 86400),
      hours: Math.floor((difference % 86400) / 3600),
      minutes: Math.floor((difference % 3600) / 60),
      seconds: difference % 60,
    };
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState<Countdown>(calculateTimeLeft);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [calculateTimeLeft]);

  return timeLeft;
}
